/* Pique & File — reels : lecture auto muette quand visible, son au tap, une seule vidéo sonore à la fois.
   Mode tuto (data-autoplay="false", 04/10) : rien ne bouge avant le tap, la vidéo se lance avec le son
   depuis le bouton lecture, les autres se mettent en pause ; un tap sur la vidéo la met en pause. */
class PfReels extends HTMLElement {
  connectedCallback() {
    this.videos = Array.from(this.querySelectorAll('video'));
    this.autoplay = this.dataset.autoplay !== 'false';
    this.videos.forEach((video) => {
      video.muted = true;
      video.setAttribute('playsinline', '');
    });
    if (!this.autoplay) {
      this.setupTap();
    } else if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.5 });
      this.videos.forEach((video) => this.observer.observe(video));
    }
    this.querySelectorAll('[data-pf-sound]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const frame = button.closest('.pf-reel__frame');
        const video = frame && frame.querySelector('video');
        if (!video) return;
        const unmute = video.muted;
        this.videos.forEach((other) => {
          other.muted = true;
          other.closest('.pf-reel__frame').classList.remove('pf-reel__frame--sound');
        });
        if (unmute) {
          video.muted = false;
          frame.classList.add('pf-reel__frame--sound');
          video.play().catch(() => {});
        }
        this.syncSoundLabels();
      });
    });
  }

  setupTap() {
    this.videos.forEach((video) => {
      const frame = video.closest('.pf-reel__frame');
      video.loop = false;
      video.addEventListener('play', () => frame.classList.add('pf-reel__frame--playing'));
      video.addEventListener('pause', () => frame.classList.remove('pf-reel__frame--playing'));
      video.addEventListener('ended', () => {
        frame.classList.remove('pf-reel__frame--playing');
        video.currentTime = 0;
      });
      video.addEventListener('click', () => {
        if (!video.paused) video.pause();
      });
    });
    this.querySelectorAll('[data-pf-play]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const frame = button.closest('.pf-reel__frame');
        const video = frame && frame.querySelector('video');
        if (!video) return;
        this.videos.forEach((other) => {
          if (other === video) return;
          other.pause();
          other.muted = true;
          other.closest('.pf-reel__frame').classList.remove('pf-reel__frame--sound');
        });
        video.muted = false;
        frame.classList.add('pf-reel__frame--sound');
        this.syncSoundLabels();
        video.play().catch(() => {
          // lecture sonore refusée par le navigateur : on relance sans le son
          video.muted = true;
          frame.classList.remove('pf-reel__frame--sound');
          this.syncSoundLabels();
          video.play().catch(() => {});
        });
      });
    });
  }

  syncSoundLabels() {
    this.querySelectorAll('[data-pf-sound]').forEach((button) => {
      const video = button.closest('.pf-reel__frame').querySelector('video');
      button.setAttribute('aria-label', video && !video.muted ? 'Couper le son' : 'Activer le son');
    });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}
customElements.define('pf-reels', PfReels);
